import { useHotelInfo } from "@/components/features/_hooks/use-hotel-info";

import { useAccommodationHotelPolicyI18nFormModelContext } from "../../../../../../context";

export const useHotelInfoOfHotelPolicyI18n = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyI18nFormModelContext();
	const { hotelInfo } = viewModel;

	return useHotelInfo({ hotelInfo, onSetViewModel });
};
